











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CategoryItem extends Vue {
    @Prop() category!: any;

    categoryOnClick (): void {
        //console.log(`Comp: User clicked on ${this.category.short}`)
        this.$emit('category-on-click', this.category)
    }
}
